import type { Gradient } from '@jouzen/ecom-components/v3/RadialGradient';

export const metabolicHealthPageGradients: Gradient[] = [
  {
    hex: '#E8DFD2',
    id: 'orange-1',
    opacity: 1,
    position: [80, 62],
    shape: 'circle',
    size: 20,
  },
  {
    hex: '#E8DFD2',
    id: 'orange-2',
    opacity: 1,
    position: [10, 33],
    shape: 'circle',
    size: 15,
  },
  {
    hex: '#E8DFD2',
    id: 'orange-3',
    opacity: 1,
    position: [15, 95],
    shape: 'circle',
    size: 20,
  },
  {
    hex: '#FDFAF7',
    id: 'orange-4',
    opacity: 1,
    position: [45, 75],
    shape: 'circle',
    size: 16,
  },
];
